import bigQuery from '@/pages/datalab/assets/svg/big-query.svg';
import starRocks from '@/pages/datalab/assets/svg/star-rocks.svg';
import postgres from '@/pages/datalab/assets/svg/post-gres.svg';
import clickHouse from '@/pages/datalab/assets/svg/click-house.svg';

import type { IYamlWorkflow } from './types';

/**
 * Agent Cube 配置向导步骤（四步）
 */
export enum WizardStep {
  One = 'one',
  Two = 'two',
  Three = 'three',
  Four = 'four',
}

export const WIZARD_STEP_ORDER: WizardStep[] = [
  WizardStep.One,
  WizardStep.Two,
  WizardStep.Three,
  WizardStep.Four,
];

export const DATABASE_ICON: Record<string, string> = {
  bigquery: bigQuery,
  postgres,
  starrocks: starRocks,
  clickhouse: clickHouse,
};

/**
 * Step4 进入时重置用：YAML 测试工作流初始快照（与 `IYamlWorkflow` 一致）。
 */
export const INITIAL_YAML_WORKFLOW: IYamlWorkflow = {
  testPhase: 'idle',
  rows: [
    { key: 'yaml', status: 'pending' },
    { key: 'sample', status: 'pending' },
  ],
  testRequestLoading: false,
  saveDraftLoading: false,
  publishLoading: false,
};